import { CORPORATIVE_VIDEO_1_URL, CORPORATIVE_VIDEO_2_URL, FINGO_FIVE_YEARS_URL } from '../links';

const corporativeVideosData = {
  title: 'Nuestra forma de trabajar',
  description: 'Conoce cómo en Fingo trabajamos para ofrecer lo máximo a nuestros clientes.',
  videos: [
    { id: 0, src: FINGO_FIVE_YEARS_URL, imageResource: 'images/videos/fingo_five_years_video.png' },
    { id: 1, src: CORPORATIVE_VIDEO_1_URL, imageResource: 'images/videos/corporative-video-1.png' },
    { id: 2, src: CORPORATIVE_VIDEO_2_URL, imageResource: 'images/videos/corporative-video-2.png' },
  ],
};

export default corporativeVideosData;
